export default {
    props: {
        source: {
            type: String,
        },
        target: {
            type: String,
            required: true,
        },
    },
    data () {
        return {
            targetList: [],
        };
    },
    methods: {
        handleScroll(evt) {
            if (!this.targetList.length) {  // Load the target list on the first scroll
                this.initializeTargetList();
            }

            if (this.targetList.length) {
                this.targetList.forEach(target => {
                    target.onScroll(evt);
                });
            }
        },
        initializeTargetList() {
            let element = this.$parent;

            while (element !== null) {    // Look for targets in the ancestors
                const targetList = element.$refs[this.target];

                if (targetList !== null) {
                    this.targetList = targetList;
                    element = null;
                }
                else {
                    element = element.$parent;
                }
            }

            if (!this.targetList.length) {
                this.sourceElement.removeEventListener('scroll', this.handleScroll);
            }
        },
    },
    mounted() {
        this.sourceElement.addEventListener('scroll', this.handleScroll);
    },
    computed: {
        sourceElement () {
            return this.source || this.$el;    // If unspecified, the source is the child of <notify-scroll>
        },
    },
    render() {
        return this.$slots.default?.()?.[0];   // Renders only the first child!
    },
};